export type GapKind = 'small' | 'large'

export type RoundingMode = 'round' | 'floor' | 'ceil'

export type ContainerWidthRule =
  | { kind: 'fixed'; width: number }
  | { kind: 'responsive'; min: number; max: number; padding: number }

export interface XPreviewProfile {
  name: string
  containerWidthRule: ContainerWidthRule
  gapCssPx: Record<GapKind, number>
  maxAspectRatio: number
  minAspectRatio?: number
  borderThicknessCssPx: number
  rounding: RoundingMode
  defaultGapKind: GapKind
}

const createFixedProfile = (params: {
  name: string
  width: number
  gapSmall: number
  gapLarge: number
  maxAspectRatio: number
  rounding: RoundingMode
  defaultGapKind: GapKind
}): XPreviewProfile => ({
  name: params.name,
  containerWidthRule: { kind: 'fixed', width: params.width },
  gapCssPx: { small: params.gapSmall, large: params.gapLarge },
  maxAspectRatio: params.maxAspectRatio,
  borderThicknessCssPx: 0,
  rounding: params.rounding,
  defaultGapKind: params.defaultGapKind
})

export const webTextBelowProfile: XPreviewProfile = createFixedProfile({
  name: 'web-text-below',
  width: 560,
  gapSmall: 12,
  gapLarge: 48,
  maxAspectRatio: 5,
  rounding: 'round',
  defaultGapKind: 'small'
})

export const webTextAboveProfile: XPreviewProfile = createFixedProfile({
  name: 'web-text-above',
  width: 560,
  gapSmall: 12,
  gapLarge: 48,
  maxAspectRatio: 5,
  rounding: 'round',
  defaultGapKind: 'large'
})

export const mobileAppLikeProfile: XPreviewProfile = {
  name: 'mobile-app-like',
  containerWidthRule: { kind: 'responsive', min: 320, max: 500, padding: 16 },
  gapCssPx: { small: 10, large: 16 },
  maxAspectRatio: 5,
  borderThicknessCssPx: 0,
  rounding: 'ceil',
  defaultGapKind: 'small'
}

export const xPreviewProfiles: XPreviewProfile[] = [
  webTextBelowProfile,
  webTextAboveProfile,
  mobileAppLikeProfile
]
